import React from 'react';
import { Link } from 'react-router-dom';
import dugoutLogo from '../../assets/dugout-logo.svg';
import dugoutIcon from '../../assets/dugout-icon.svg';
import { cn } from '../../lib/utils';

/**
 * Dugout Labs brand lockup for the app sidebar.
 */
export default function BrandLockup({
  to = '/dashboard',
  collapsed = false,
  className,
  asLink = true,
}) {
  const content = collapsed ? (
    <img src={dugoutIcon} alt="Dugout" className="h-7 w-7 object-contain" />
  ) : (
    <img src={dugoutLogo} alt="Dugout Labs" className="h-8 w-auto max-w-[148px] object-contain" />
  );

  if (!asLink) {
    return (
      <span className={cn('inline-flex items-center', className)} aria-label="Dugout Labs">
        {content}
      </span>
    );
  }

  return (
    <Link to={to} className={cn('inline-flex items-center no-underline', className)} aria-label="Dugout Labs">
      {content}
    </Link>
  );
}
